import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";
import Modal from "@/atomic/atoms/Modal";
import TicketModal from "@/atomic/organisms/TicketModal";
import Loading from "@/atomic/atoms/Loading";
import useI18n from "@/hooks/useI18n";
import PlanSelection from "@/atomic/organisms/PlanSelection";

export default function CheckoutFinishedView({
  goBack,
  invoice,
  toggleModal,
  generatePDF,
  isVisibleModal,
  isLoading,
  openInvoice,
  error,
  toggleError,
  toggleModalRegister,
  handleTryAgain,
}: PropsView) {

  const { t } = useI18n();
  return (
    <div className="h-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
       

        <main className="px-4 py-3 md:py-6 flex justify-center items-center h-[calc(100vh-72px)] overflow-y-auto">
        <article className="h-full flex flex-col w-full items-center justify-center">
          <div className="flex flex-col w-full max-w-[1400px] mx-auto justify-center">
            <div className="flex items-center justify-center w-full flex-col mb-4 md:mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-10 h-10 md:w-12 md:h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-xl md:text-3xl font-bold text-black text-center mb-1 md:mb-2">Sucesso!</h2>
              <h3 className="text-xs md:text-base text-center text-[#525252] px-2">Seu pagamento foi realizado.</h3>
            </div>
            
            <div className="flex justify-center items-center w-full mx-auto mb-3 md:mb-6">
              <PlanSelection />
            </div>

            <div className="w-full max-w-full md:w-[calc(480px)] mx-auto">
            <div className="flex items-center flex-col mt-8 md:mt-6 px-2">
            <button onClick={openInvoice} type="button" className="w-full h-[calc(60px)] rounded-lg border bg-transparent border-black text-black font-medium mb-4">{t("pages:success:receipt")}</button>
            <button onClick={goBack} type="button" className="w-full h-[calc(60px)] rounded-lg bg-transparent text-black font-medium">{t("pages:success:exit")}</button>
          </div>
            </div>
          </div>
        </article>
      </main>
      {isLoading && <Loading />}
      {isVisibleModal && invoice && (
        <TicketModal
          invoice={invoice}
          generatePDF={generatePDF || (() => {})}
          toggleModal={toggleModal || (() => {})}
          toggleModalRegister={toggleModalRegister || (() => {})}
        />
      )}
      {error && (
        <Modal
          title="Ops"
          message={t("pages:receipt:description")}
          actionMessage={t("pages:receipt:checkAgain")}
          action={handleTryAgain}
          actionSecond={toggleError}
          actionSecondMessage={t("common:close")}
        />
      )}
    </div>
  );
}
